import React,{ useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './style.less';
import RcMenu, { SubMenu, MenuItem } from 'rc-menu';
import {RightOutlined,DownOutlined} from '@ant-design/icons';

type ItemType = {
  title: React.ReactNode;
  icon?: React.ReactNode;
  url?: string;
  key: string;
  children?: ItemType[];
};
type MenuProps = {
  items: ItemType[];
  defaultSelectedKeys: string[];
};

const flattenArr = arr =>
  arr.reduce(
    (result, item) => [
      ...result,
      { ...item },
      ...(item.children ? flattenArr(item.children) : [])
    ],
    []
  );
const arrToObj = arr => {
  return arr.reduce((result, item) => {
    result[item.key] = item;
    return result;
  }, {});
};
const Menu = (props: MenuProps) => {
  const { defaultSelectedKeys, items } = props;
  const [openkey, setOpenKey] = useState<any>([]);

  const openKeys = items?.map(item => item.key);
  const history = useHistory();
  const flattenedArr = flattenArr(items);
  const itemsMap = arrToObj(flattenedArr);


  // 点击 MenuItem 调用
  const handleClick = (item: any) => {
    history.push(itemsMap[item.key].url);
  };

  // SubMenu 展开/关闭的回调
  const onOpenChange = (keys) => {
    setOpenKey(keys)
  }
  return (
    <RcMenu
      className="menu"
      onClick={handleClick}
      // onOpenChange={onOpenChange}
      openKeys={openKeys}
      mode="inline"
      selectedKeys={defaultSelectedKeys}
      inlineIndent={30} /*恰好工作*/
    >
      {items?.map(item =>
        item.children ? (
          <SubMenu
            key={item.key}
            title={
              <>
                {item.icon && <span className="icon">{item.icon}</span>}
                {item.title}
              </>
            }
          >
            {item.children.map(item => (
              <MenuItem key={item.key}>
                {item.icon && <span className="child-icon">{item.icon}</span>}
                {item.title}
              </MenuItem>
            ))}
          </SubMenu>
        ) : (
          <MenuItem key={item.key}>
            {item.icon && <span className="icon">{item.icon}</span>}
            {item.title}
          </MenuItem>
        )
      )}
    </RcMenu>
  );
};
export default Menu;
